import { Box, Hidden, Stack } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import LogoIcon from "src/assets/svg-icons/logo.svg";
import SideBarItem from "./sidebar-item";
import MobileSidebar from "./mobile-sidebar";
import { sideBarItems } from "./constants";
import JazrAppBar from "./app-bar";
import { useOneBranchHasPermission } from "../hooks/has-permission-hook";
import {
  IntegrationsPermissions,
  MenuPermissions,
} from "src/constants/permissions";

export const Layout: React.FC = () => {
  const hasPermission = useOneBranchHasPermission();

  const viewMenu =
    hasPermission(MenuPermissions.viewProducts) ||
    hasPermission(MenuPermissions.viewModifiers) ||
    hasPermission(MenuPermissions.viewCategories);

  const viewIntegrations = hasPermission(
    IntegrationsPermissions.viewIntegration,
  );

  return (
    <Box
      display={"flex"}
      flexDirection={{ xs: "column", md: "row" }}
      maxWidth={"100vw"}
    >
      {/* sidebar */}
      <Hidden mdDown>
        <Stack
          maxWidth={"252px"}
          minWidth={"252px"}
          py={3}
          borderRight={"1px solid #D0D5DD"}
          height={"100vh"}
          maxHeight={"100vh"}
          overflow={"auto"}
          position={"sticky"}
          top={"0"}
        >
          <Box px={"40px"} mb={"48px"}>
            <img src={LogoIcon} width={90} alt="" />
          </Box>
          {sideBarItems.map((item) => {
            if (
              (item.label === "menu" && !viewMenu) ||
              (item.label === "integrations" && !viewIntegrations)
            ) {
              return;
            }
            return (
              <SideBarItem
                key={item.path}
                label={item.label}
                icon={item.icon}
                path={item.path}
              />
            );
          })}
        </Stack>
      </Hidden>

      <Hidden mdUp>
        <MobileSidebar />
      </Hidden>

      {/* pages content — minWidth: 0 lets wide tables shrink and scroll instead of clipping */}
      <Box flexGrow={1} sx={{ minWidth: 0, maxWidth: "100%" }}>
        <JazrAppBar />
        <Outlet />
      </Box>
    </Box>
  );
};
